import { useEffect } from "react";
import { useLocation,useNavigate } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const scrollPositions = {
    "/jobs": 60,
    "/contact-us": 100,
    "/about": 150,
    "/login":160,
    "/register":60,
    "/allcandidates":150,
    "/candidatedashboard":100,
    "/employerdashboard":150,
    "/postjob":150,

  };

  useEffect(() => {
    window.scrollTo(0,0);
    if (scrollPositions.hasOwnProperty(pathname)) {
      window.scrollTo({ top: scrollPositions[pathname], behavior: "smooth" });
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
